import { useRouter } from 'next/router';

export const useShowFilterState = (isCrawler = false) => {
  const { pathname } = useRouter();
  const pathUrl = pathname.split('/')[1];

  const showAvailableNowFilter = !isCrawler && pathUrl !== 'timeline';
  const showBrandFilter = pathUrl !== 'brand';
  const showCategoryFilter = pathUrl !== 'timeline';
  const showColorFilter = pathUrl !== 'timeline' && pathname !== `/[pageSlug]/color/[colorValue]`;
  const showConditionFilter = pathUrl !== 'timeline' && pathUrl !== 'goat-clean';
  const showDiscountTagFilter =
    !isCrawler && pathUrl !== 'timeline' && pathname !== '/sneakers/under-retail';
  const showGenderFilter = pathUrl !== 'timeline';
  const showInstantFilter =
    !isCrawler &&
    pathUrl !== 'timeline' &&
    pathUrl !== 'goat-clean' &&
    pathUrl !== 'instant' &&
    pathname !== '/sneakers/under-retail';
  const showPriceFilter = pathUrl !== 'timeline';
  const showSizeFilter = pathUrl !== 'timeline';
  const showYearFilter = pathUrl !== 'timeline' && pathUrl !== 'goat-clean';

  return {
    showAvailableNowFilter,
    showBrandFilter,
    showCategoryFilter,
    showColorFilter,
    showConditionFilter,
    showDiscountTagFilter,
    showGenderFilter,
    showInstantFilter,
    showPriceFilter,
    showSizeFilter,
    showYearFilter,
  };
};
